import { HardwareCategory } from '@enmon/commons/lib/tools';
import type { DefaultOptionType } from 'antd/lib/select';

export const HARDWARE_FORM_ID = 'hardware-form' as const;

export const HARDWARE_CATEGORIES_TRANSLATED = {
  [HardwareCategory.ElectricityMeter]: 'Electricity meter',
  [HardwareCategory.GasMeter]: 'Gas meter',
  [HardwareCategory.WaterMeter]: 'Water meter',
  [HardwareCategory.HeatMeter]: 'Heat meter',
  [HardwareCategory.Module]: 'Module',
  [HardwareCategory.Sensor]: 'Sensor',
  [HardwareCategory.Splitter]: 'Splitter',
  [HardwareCategory.Other]: 'Other',
} as const;

export const hardwareCategoriesOptions: DefaultOptionType[] = Object.values(HardwareCategory).map(category => ({
  value: category,
  label: HARDWARE_CATEGORIES_TRANSLATED[category],
}));

export enum ShoppingCartTab {
  HardwareList = 'hardware-list',
  Versions = 'versions',
  Settings = 'settings',
}

export const SHOPPING_CART_TABS_TRANSLATED = {
  [ShoppingCartTab.HardwareList]: 'Hardware List',
  [ShoppingCartTab.Versions]: 'Versions',
  [ShoppingCartTab.Settings]: 'Settings',
} as const;
